@if (product().bundleType && product().bundle; as bundle) {
  <ui-product-detail-bundle-form
    (addToShoppingList)="addToShoppingList.emit($event)"
    [bundle]="bundle"
    [product]="product()"
  ></ui-product-detail-bundle-form>
} @else {
  <ui-product-detail-form
    (addToShoppingList)="addToShoppingList.emit($event)"
    [product]="product()"
  ></ui-product-detail-form>
}
